import React from 'react'
import "./../PopImage/PopImage.css"
import assets from '../../assets/assets'

function DetailsImagePopup({ setOpenImg, imgSrc }) {
    return (
        <div>
            <div className=" delete_activity_transprant_body ">

                <div className="d-flex align-items-center justify-content-center flex-column relative">
                    <img
                        style={{ position: "absolute", top: "0%", right: "0%" }}
                        src={assets.CrossIcon}
                        className="p-2 w-10 cursor-pointer"
                        alt=""
                        onClick={(e) => setOpenImg(false)}
                    />
                    <img src={imgSrc} alt='img' style={{ width: "100%", height: "80%" }}></img>
                </div>
            </div>
        </div>
    )
}

export default DetailsImagePopup